<!-------------Footer Start----------------->
<!-- Please don’t change these IDs because those are for automated testing: footerMenuAboutUsLink, footerMenuTermsOfUseLink, footerMenuPrivacyPolicyLink -->
<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-5 col-sm-6"><p>© {{currentYear}} Wellbux, Inc. All Rights reserved</p></div>
      <div class="col-lg-6 col-md-7 col-sm-6 text-right">
        <ul>
          <li><a id="footerMenuAboutUsLink" routerLink="/about-us" routerLinkActive="active" href="javascript:void(0)">About Us</a></li>
          <li><a id="footerMenuTermsOfUseLink" routerLink="/terms-of-use" routerLinkActive="active" href="javascript:void(0)">Terms of Use</a></li>
          <li><a id="footerMenuPrivacyPolicyLink" routerLink="/privacy-policy" routerLinkActive="active" href="javascript:void(0)">Privacy Policy</a></li>
         
        </ul>
      </div>
    </div>
  </div>
</footer>
<!-------------Footer End----------------->
